<div class="reveal" [ngClass]="{'reveal-open': open === true}">
  <svg-icon (click)="toggleMenu()"
            class="reveal-toggle"
            [src]="'../../../assets/img/icons/ellipsis-vertical.svg'"></svg-icon>
  <div *ngIf="open" class="reveal-list">
    <ng-content></ng-content>
  </div>
</div>
